module.exports = __webpack_public_path__ + "static/img/third_post.42ca706.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/third_post.png
// module id = TxEL
// module chunks = 37